import React from 'react';
import { METRIC_LABELS } from '../../../../constants/performance';
import { formatPeriod } from '../utils/professorTiers';

const ProfessorMetricsList = ({ professor }) => {

    const sortedMetrics = Object.entries(professor.scoreBreakdown || {})
        .filter(([key]) => METRIC_LABELS[key] && key !== "raw" && key !== "weights")
        .sort((a, b) => {
            const labelA = METRIC_LABELS[a[0]] || a[0];
            const labelB = METRIC_LABELS[b[0]] || b[0];
            return labelA.localeCompare(labelB);
        });

    return (
        <div style={{ padding: '0 8px', marginBottom: '40px' }}>
            <div className="p-3 p-md-4"
                style={{
                    backgroundColor: 'rgba(255,255,255,0.04)',
                    borderRadius: '20px',
                    border: '1px solid rgba(255,255,255,0.06)',
                    backdropFilter: "blur(10px)"
                }}>

                <div className="d-flex flex-column flex-sm-row justify-content-between align-items-center gap-3 mb-4 mt-2 px-2">
                    <div className="text-center text-sm-start">
                        <h4 className="mb-0 fw-bold font-size-20 font-size-md-22" style={{ color: "rgba(255,255,255,0.9)" }}>
                            Matriz de Habilidades
                        </h4>
                    </div>
                    <div className="text-center text-sm-end">
                        <span className="font-size-13 fw-semibold d-flex align-items-center gap-1"
                            style={{ color: "rgba(255,255,255,0.3)", letterSpacing: "0.5px" }}>
                            <i className="mdi mdi-calendar-blank"></i>
                            {formatPeriod(professor.period)}
                        </span>
                    </div>
                </div>

                <div className="d-flex flex-column gap-2 px-1">
                    {sortedMetrics.map(([key, data]) => {
                        const label = METRIC_LABELS[key] || key;
                        const weightPercent = Math.round((data.weight || 0) * 100);
                        const value = Math.min(100, Math.max(0, data.normalized || 0));
                        const valueFormatted = Number(value).toFixed(1);

                        // Color by value
                        const barColor = value >= 80 ? "#34c38f" : value >= 60 ? "#f1b44c" : value >= 40 ? "#f46a6a" : "#74788d";

                        return (
                            <div key={key}
                                className="d-flex align-items-center gap-3 py-3 px-3 rounded-3"
                                style={{
                                    background: "rgba(255,255,255,0.02)",
                                    border: "1px solid rgba(255,255,255,0.04)",
                                    transition: "all 0.2s"
                                }}>

                                {/* Label */}
                                <div className="flex-grow-1 overflow-hidden">
                                    <div className="fw-semibold font-size-14 font-size-md-16 text-truncate" style={{ color: "rgba(255,255,255,0.8)" }}>
                                        {label}
                                    </div>
                                    <span className="font-size-11" style={{ color: "rgba(255,255,255,0.25)" }}>
                                        peso: {weightPercent}%
                                    </span>
                                </div>

                                {/* Progress Bar */}
                                <div className="flex-shrink-0" style={{ width: "120px" }}>
                                    <div style={{
                                        height: "6px",
                                        backgroundColor: "rgba(255,255,255,0.06)",
                                        borderRadius: "3px",
                                        overflow: "hidden"
                                    }}>
                                        <div style={{
                                            width: `${value}%`,
                                            height: "100%",
                                            backgroundColor: barColor,
                                            borderRadius: "3px",
                                            transition: "width 0.6s ease"
                                        }} />
                                    </div>
                                </div>

                                {/* Value */}
                                <div className="text-end flex-shrink-0" style={{ minWidth: "55px" }}>
                                    <span className="fw-bold font-size-16" style={{ color: barColor }}>
                                        {valueFormatted}
                                    </span>
                                    <span className="font-size-11 ms-1" style={{ color: "rgba(255,255,255,0.25)" }}>%</span>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default ProfessorMetricsList;
